(function () {
    'use strict';

    angular.module('app.getProducts', ['smart-table', 'treeControl', 'ui.bootstrap', 'ngTable']);
})();